/**
 * MUI theme's colors liked to the colors defines in the `theme.js` root file.
 * Some MUI components required a color attribute with this string values.
 * Ex: <Button color={colorTypes.PRIMARY}/>
 * @see /theme.js
 */
export const colorTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  ERROR: 'error'
}
